import React, { Component } from 'react';
import * as Request from '../../service/data-info-chart/requestsUtil';
import '../../../node_modules/rc-rate/assets/index.css';
import history from '../../resources/images/estrategas/tools/history.png';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Label } from 'reactstrap';
import ViewSummaryFiles from './viewSummaryFiles';

class ViewSummary extends Component {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { modal: false };
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  componentDidMount() {
    Request.getFetch(this.props.url)
      .then(resp => {
        this.summary = resp.map(arr=>{
          return <div className='d-flex justify-content-center' key={arr.timestamp}>
            <p>{arr.timestamp}</p>
            <ViewSummaryFiles url={arr.url}/>
          </div>
        });
      });
  }

  render() {
    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader className='header-modal'
                       toggle={this.toggle}>Archivos subidos del Periodo {this.props.dateModal}</ModalHeader>
          <ModalBody className='modal-overflow'>
            {this.summary}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggle}>Aceptar</Button>
          </ModalFooter>
        </Modal>
        <div className='quality-edit'>
          <img src={history} title="Ver" alt=" " onClick={this.toggle}/>
        </div>
      </div>
    );
  }
}

export default ViewSummary;



// WEBPACK FOOTER //
// ./src/components/buttons/viewSummary.js